import React, { Component } from 'react';
import { oneOfType, string, object, any, bool } from 'prop-types';
import { get, orderBy } from 'lodash';
import QueryManager from './Query';
import { GET_SALES_CHANNELS } from '../../queries';
import UserSession from '../auth/UserSession';

class GetSalesChannels extends Component {
    static propTypes = {
        query: oneOfType([string, object]),
        children: any,
        variables: any,
        allSalesChannels: bool
    }

    static defaultProps = {
        allSalesChannels: false,
        query: GET_SALES_CHANNELS
    }

    _getAllSalesChannels = () => {
        const { children, query, variables = {}, allSalesChannels, ...props } = this.props;
        return (
            <QueryManager
                fetchPolicy='cache-and-network'
                query={query}
                variables={{ ...variables }}
                {...props}
            >
                { ({ data, loading, fetchMore, refetch }) => {
                    return children({
                        data: orderBy(get(data, 'salesChannels', []), ['name', 'desc']),
                        refetch,
                        loading
                    });
                } }
            </QueryManager>
        );
    }

    _getUserSalesChannels = () => {
        const { children } = this.props;

        return (
            <UserSession typeCache={true}>
                { ({ salesChannels, loading, fetchMore, refetch } ) => {
                    return children({
                        data: orderBy(salesChannels, ['name', 'desc']),
                        refetch,
                        loading
                    });
                } }
            </UserSession>
        );
    }

    render () {
        const { allSalesChannels } = this.props;
        return allSalesChannels ? this._getAllSalesChannels() : this._getUserSalesChannels();
    }
}

export default GetSalesChannels;
